import { PriceRoundingRuleConfigDTO } from '../dto';
import { RoundingRuleRange } from './RoundingRuleRange';

export type PriceRoundingRuleConfigAction = 'UPDATE' | 'DELETE';

export interface PriceRoundingBrand {
  name: string;
  id: string;
  imgUrl: string;
}

interface PriceRoundingRuleConfigProps {
  id: number;
  name: string;
  ranges: RoundingRuleRange[];
  actions: PriceRoundingRuleConfigAction[];
  centralOwner?: PriceRoundingBrand;
}

export class PriceRoundingRuleConfig {
  id: number;
  name: string;
  ranges: RoundingRuleRange[];
  actions: PriceRoundingRuleConfigAction[] = [];
  centralOwner?: PriceRoundingBrand;

  constructor({ id, name, ranges, actions, centralOwner }: PriceRoundingRuleConfigProps) {
    this.id = id;
    this.name = name;
    this.ranges = ranges;
    this.actions = actions;
    this.centralOwner = centralOwner;
  }

  isEditable = (): boolean => this.actions.includes('UPDATE');

  isDeletable = (): boolean => this.actions.includes('DELETE');

  static fromDto(
    dto: PriceRoundingRuleConfigDTO,
    selectedBrand: PriceRoundingBrand,
    actions: PriceRoundingRuleConfigAction[] = []
  ): PriceRoundingRuleConfig {
    return new PriceRoundingRuleConfig({
      id: dto.id,
      name: dto.name,
      ranges: dto.intervals
        .map(RoundingRuleRange.fromDto)
        .sort((a, b) => a.priceFrom - b.priceFrom),
      centralOwner: dto.type === 'BRAND' ? selectedBrand : undefined,
      actions,
    });
  }
}
